"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FaqClientModel = void 0;
var loader_1 = require("./loader");
var FaqClientModel = (function () {
    function FaqClientModel() {
    }
    FaqClientModel.prototype.Init = function () {
        window.onpopstate = this.PopState;
        if (this.Selected !== 0) {
            var selected = document.getElementById('question-' + this.Selected);
            if (selected != null)
                selected.scrollIntoView();
        }
        $('.js-faq-answer').on('show.bs.collapse', this.OnShow);
    };
    FaqClientModel.prototype.PopState = function (ev) {
        if (ev.state !== '0')
            $('#answer-' + ev.state).collapse('show');
    };
    FaqClientModel.prototype.OnShow = function (t) {
        var args = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            args[_i - 1] = arguments[_i];
        }
        if (window.location.pathname.match(new RegExp('/' + t.target.dataset['id'] + '$')))
            return;
        if (/\d$/.test(window.location.pathname)) {
            history.replaceState(t.target.dataset['id'], null, t.target.dataset['id']);
        }
        else if (/\/$/.test(window.location.pathname)) {
            history.replaceState(t.target.dataset['id'], null, window.location.pathname + t.target.dataset['id']);
        }
        else {
            history.replaceState(t.target.dataset['id'], null, window.location.pathname + '/' + t.target.dataset['id']);
        }
    };
    return FaqClientModel;
}());
exports.FaqClientModel = FaqClientModel;
(0, loader_1.InitClientContext)(FaqClientModel);
